import { useId } from "react";

import { SKINS, type SkinId } from "./skins";

export function AppearanceSelector({ skin, onSkinChange }: {
  skin: SkinId;
  onSkinChange: (skin: SkinId) => void;
}) {
  const groupId = useId();

  return (
    <fieldset className="appearance-selector">
      <legend>Appearance</legend>
      <div className="appearance-options">
        {SKINS.map((option) => (
          <label className="appearance-option" data-skin={option.id} data-selected={skin === option.id} key={option.id}>
            <input
              type="radio"
              name={`appearance-${groupId}`}
              value={option.id}
              checked={skin === option.id}
              aria-labelledby={`${groupId}-${option.id}-name`}
              aria-describedby={`${groupId}-${option.id}-description`}
              onChange={() => onSkinChange(option.id)}
            />
            <span className="appearance-swatch" aria-hidden="true" />
            <span className="appearance-option-copy">
              <strong id={`${groupId}-${option.id}-name`}>{option.name}</strong>
              <small id={`${groupId}-${option.id}-description`}>{option.description}</small>
            </span>
          </label>
        ))}
      </div>
    </fieldset>
  );
}
